import axios from "axios";
import { toast } from "react-toastify";
const baseUrl = process.env.REACT_APP_BASE_URL;

export const CREATE_GIF_REQUEST = "CREATE_GIF_REQUEST";
export const CREATE_GIF_SUCCESS = "CREATE_GIF_SUCCESS";
export const CREATE_GIF_FAILURE = "CREATE_GIF_FAILURE";

export const UPDATE_GIF_REQUEST = "UPDATE_GIF_REQUEST";
export const UPDATE_GIF_SUCCESS = "UPDATE_GIF_SUCCESS";
export const UPDATE_GIF_FAILURE = "UPDATE_GIF_FAILURE";

export const DELETE_GIF_REQUEST = "DELETE_GIF_REQUEST";
export const DELETE_GIF_SUCCESS = "DELETE_GIF_SUCCESS";
export const DELETE_GIF_FAILURE = "DELETE_GIF_FAILURE";

export const LIST_GIF_REQUEST = "LIST_GIF_REQUEST";
export const LIST_GIF_SUCCESS = "LIST_GIF_SUCCESS";
export const LIST_GIF_FAILURE = "LIST_GIF_FAILURE";

export const createGif = (data, toggle, setData) => {
    return async (dispatch) => {
        try {
            dispatch({ type: CREATE_GIF_REQUEST });
            // upload icon on s3
            const imgRes = await axios.post(`${process.env.REACT_APP_BASE_URL}/s3/upload/yaadein/gifs/v1`, {
                sFileName: data.icon.file.name,
                sContentType: data.icon.file.type
            }, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            const imageUrl = imgRes.data.data.sUrl
            const sImage = imgRes.data.data.sPath
            await axios.put(imageUrl, data.icon.file, { headers: { "Content-Type": data.icon.file.type } });

            const url = `${baseUrl}/yaadein/gifs/create/v1`;
            const response = await axios.post(url, { ...data, src: sImage }, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: CREATE_GIF_SUCCESS, payload: response.data });
            toast("Gif Created Successfully.");
            toggle();
            setData({
                name: "",
                icon: "",
                isInput: false,
                placeholder: ""
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: CREATE_GIF_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};

export const updateGif = (id, data, toggle, setData, setSelectedData) => {
    return async (dispatch) => {
        try {
            dispatch({ type: UPDATE_GIF_REQUEST });
            let icon = "";

            // upload icon on s3
            if (data && data.icon && data.icon.file) {
                const imgRes = await axios.post(`${process.env.REACT_APP_BASE_URL}/s3/upload/yaadein/gifs/v1`, {
                    sFileName: data.icon.file.name,
                    sContentType: data.icon.file.type
                }, {
                    headers: {
                        Authorization: localStorage.getItem("token")
                    }
                });
                const imageUrl = imgRes.data.data.sUrl
                icon = imgRes.data.data.sPath
                await axios.put(imageUrl, data.icon.file, { headers: { "Content-Type": data.icon.file.type } });
            }

            const url = `${baseUrl}/yaadein/gifs/update/${id}/v1`;
            const response = await axios.put(url, { ...data, src: icon === "" ? data.icon : icon }, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: UPDATE_GIF_SUCCESS, payload: response.data });
            toast("Gif Updated Successfully.");
            toggle();
            setData({
                name: "",
                icon: "",
                isInput: false,
                placeholder: "",
            });
            setSelectedData({});
        } catch (error) {
            console.error(error);
            dispatch({ type: UPDATE_GIF_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};

export const deleteGif = (id, selectedData, toggle) => {
    return async (dispatch) => {
        try {
            dispatch({ type: DELETE_GIF_REQUEST });
            const url = `${baseUrl}/yaadein/gifs/delete/${id}/v1`;
            const response = await axios.delete(url, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: DELETE_GIF_SUCCESS, payload: id });
            toast("Gif Deleted Successfully.");
            toggle();
            selectedData({});
        } catch (error) {
            console.error(error);
            dispatch({ type: DELETE_GIF_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};

export const listGif = (page) => {
    return async (dispatch) => {
        try {
            dispatch({ type: LIST_GIF_REQUEST });
            const url = `${baseUrl}/yaadein/gifs/admin/list/v1?skip=${page}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: LIST_GIF_SUCCESS, payload: response.data });
        } catch (error) {
            console.error(error);
            dispatch({ type: LIST_GIF_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};